import { ColDef } from 'ag-grid-community';
import { renderNA, importErrorFunction, generateImportColumn, importTextFormatEditor, formatEditor } from './../../../../../utils/commonFunctions';

/**
 * Column definitions for listing page
 * cellRenderer to show data as a string
 * valueGetter for getting data from export functionality of ag-grid
 * filterValueGetter for getting data from filter
 * tooltipValueGetter for getting data from tooltip
 * textFormatEditor for getting data from text editor
 */
// nameColumn,
const columnDefs: ColDef[] = [
  {
    ...generateImportColumn("", "name"),
    pinned: "left",
    ...importErrorFunction(),
  },
  { ...generateImportColumn("Has Leadership?", "has_leadership"), ...importErrorFunction() },
  {
    ...generateImportColumn("High School Diploma or GED", "high_school_diploma_or_ged"),
    ...importErrorFunction(),
  },
  { ...generateImportColumn("", "associate_degree"), ...importErrorFunction() },
  { ...generateImportColumn("", "bachelors_degree"), ...importErrorFunction() },
  { ...generateImportColumn("", "masters_degree"), ...importErrorFunction() },
  { ...generateImportColumn("", "pre_apprenticeship"), ...importErrorFunction() },
  { ...generateImportColumn("", "apprenticeship"), ...importErrorFunction() },
  { ...generateImportColumn("", "not_available"), ...importErrorFunction() },
  { ...generateImportColumn("", "doctoral_degree"), ...importErrorFunction() },
];
export default columnDefs;
